import $ from 'jquery';
import './slick-carousel';

import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'slides';

export const SLICK_CLASS = 'js-slides-slick';
export const STATUS_CLASS = 'js-slides-status';

export const DEFAULTS = {
  slidesToShow: 1,
  showStatus: true,
  lazyLoad: 'progressive',
  arrows: true,
};

const updatePDPSlideNum = ($status, slick) => {
  const text = `${slick.currentSlide + 1}  /  ${slick.slideCount}`;
  $status.text(text);
};

const addSlidesStatus = ($slidesWrap, $slides) => {
  $slidesWrap.append(`<div class="${STATUS_CLASS} slides__status"></div>`);
  const $status = $slidesWrap.find(`.${STATUS_CLASS}`);
  $slides
    .on('init', (event, slick) => {
      updatePDPSlideNum($status, slick);
    })
    .on('afterChange', (event, slick) => {
      updatePDPSlideNum($status, slick);
    });
};
const initSlick = ($slidesWrap, $slides, opts) => {
  if (opts.showStatus) {
    addSlidesStatus($slidesWrap, $slides);
  }
  $slides.slick(opts);
};
/**
 * Initializes slides
 * @param {HTMLElement} el - tab link
 * @param {Object} [options] - Object containing override options
 */
export default function slides(el, options = {}) {
  const $slidesWrap = $(el);
  const $slides = $slidesWrap.find(`.${SLICK_CLASS}`);
  const opts = mergeOptions(DEFAULTS, options, $slidesWrap);
  initSlick($slidesWrap, $slides, opts);
}
registerJQueryPlugin(PLUGIN_NAME, slides);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/slides.js